import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { FAQS } from '../data/content';
import { Reveal } from './Reveal';
export function FAQ() {
  const [open, setOpen] = React.useState<number | null>(0);
  return <section id="faq" className="bg-canvas py-16 sm:py-24" data-id="element-39" data-mp="1hb8e4b5g09nt">
      <div className="mx-auto grid max-w-[1240px] gap-8 px-4 sm:px-6 lg:grid-cols-[0.7fr_1.3fr] lg:gap-12 lg:px-8" data-id="element-40" data-mp="1cft11lf9ehsg">
        <Reveal data-id="element-41" data-mp="2a1gzscz6tc75">
          <p className="text-[11px] font-semibold uppercase tracking-overline text-brand-600" data-id="element-42" data-mp="29zw4gl51tp88">
            FAQ
          </p>
          <h2 className="mt-4 text-[2rem] font-semibold leading-[1.1] tracking-[-0.02em] text-ink-900 sm:text-[2.4rem]" data-id="element-43" data-mp="203jdvw4svrhp">
            Preguntas frecuentes
          </h2>
          <p className="mt-5 max-w-sm text-[14.5px] leading-relaxed text-ink-500" data-id="element-44" data-mp="1v7c5lwoxm3wl">
            Información general. Para condiciones concretas, consulta siempre la
            plataforma.
          </p>
        </Reveal>

        <div className="divide-y divide-line overflow-hidden rounded-2xl border border-line bg-white shadow-card" data-id="element-45" data-mp="1knzy6boe06tv">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-46" data-mp="1aq2cnvxwwo4y" data-mpi={i}>
                <h3 data-id="element-47" data-mp="1ap0y3hhotjih">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left transition-colors duration-200 ease-expo hover:bg-brand-50" data-id="element-48" data-mp="1arn95r3seh5g">
                    <span className="text-[15px] font-semibold text-ink-900" data-id="element-49" data-mp="rwyh2514w17p">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-brand-600 transition-transform duration-200 ease-expo ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-50" data-mp="iy4m0j3gbiw9" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-51" data-mp="2kv54naqdjzg8">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-52" data-mp="2fxvettz2plrv">
                      <p className="max-w-2xl px-6 pb-6 text-[14.5px] leading-relaxed text-ink-500" data-id="element-53" data-mp="2ym0eoqcm0mle">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}